import styled from '@emotion/styled';

import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import ToastW from '@/images/ToastW.svg';
import theme from '@/theme';

const Container = styled.div`
    display: flex;
    height: 29px;
    padding: 10px 0 11px 16px;
    align-items: center;
    flex-shrink: 0;
    background: ${({ theme }) => theme.colors.error[50]};
    position: relative;
    gap: 4px;
`;

const BannerText = styled.span`
    color: ${({ theme }) => theme.colors.secondary.main};
    font-family: Manrope;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 8px;
`;

export const VoiceCloneErrorBanner = () => {
    return (
        <Container>
            <MaskedIcon src={ToastW} size="16px" color={theme.colors.error[650]} />
            <BannerText>Voice cloning failed</BannerText>
        </Container>
    );
};
